import React from "react";
import { Grid } from "@material-ui/core";

// styles
import useStyles from "./styles";

// components
import Widget from "../../Components/Widget";
import PageTitle from "../../Components/PageTitle";
import AdRenderers from "../../Components/AdRenderers/AdRenderers";

export default function AdRenderersPage() {
  var classes = useStyles();

  return (
    <>
      <PageTitle title="Ad Renderers" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget
            title="Simple Ad Renderer"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
          >
            <AdRenderers />
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
